import { toast } from 'react-toastify';

const errorNotify = (msg) => {
  toast.error(msg, {
    theme: 'dark'
  })
}

const successNotify = (msg) => {
  toast.success(msg, {
    theme: 'dark'
  })
}

export {
  errorNotify,
  successNotify,
}